import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { Box, Typography } from '@saviynt/design-system';
import moment from 'moment';
import PropTypes from 'prop-types';

import { getMessageKey } from '../../../utils/utils';
import ARSAccordian from '../ARSAccordian';
import ARSTimeLineIconLarge from '../ARSTimeLineIconLarge';
import ARSTimeLineIconSmall from '../ARSTimeLineIconSmall';
import { DATE_FIELDS } from '../constant';

const FIELDS_TO_EXCLUDE = [
  'arsTaskLabelKey1',
  'arsTaskLabelKey2',
  'arsTaskLabel',
  'taskCreateDate',
];

function ARSTaskTile({ taskSectionTileData, globalDateFormat }) {
  if (!taskSectionTileData) return null;

  const intl = useIntl();
  const { messages } = useSelector((state) => state?.user);
  const {
    arsTaskSectionLabelKey,
    // arsTaskSectionLabeValue,
    arsTaskLabelKey1,
    arsTaskLabelKey2,
    arsTaskSectionLabelValue,
    arsTaskMap,
    arsTaskList,
    messageKeys,
  } = taskSectionTileData;

  const taskList = arsTaskList || [
    {
      ...arsTaskMap,
      arsTaskLabelKey1,
      arsTaskLabelKey2,
      arsTaskLabel: arsTaskSectionLabelValue,
    },
  ];

  return (
    <ARSAccordian>
      <ARSTimeLineIconLarge tail='none' />
      <Box tag='div' className='AccessRequestHistoryBody-accordianBox'>
        <Typography
          kind='h3'
          className='AccessRequestHistoryBody-accordianBoxTitle'>
          {messages[arsTaskSectionLabelKey] ||
            localize(intl, getMessageKey(arsTaskSectionLabelKey))}
        </Typography>
        {taskList?.length > 0 &&
          taskList.map((task, index) => (
            <ARSAccordian className='subbody--1' key={task?.taskId}>
              <ARSTimeLineIconSmall
                tail={index === taskList.length - 1 ? 'none' : 'fill'}
              />
              <Box
                tag='div'
                className='AccessRequestHistoryBody-accordianBox--subbox'>
                <Typography
                  kind='h3'
                  className='AccessRequestHistoryBody-accordianBoxTitle--subbody'>
                  {task?.arsTaskLabelKey1 && task?.arsTaskLabelKey2
                    ? `${
                        messageKeys?.[task?.arsTaskLabelKey1] ||
                        localize(intl, getMessageKey(task?.arsTaskLabelKey1))
                      } · ${
                        messageKeys?.[task?.arsTaskLabelKey2] ||
                        localize(intl, getMessageKey(task?.arsTaskLabelKey2))
                      }`
                    : `${task?.arsTaskLabel}`}
                </Typography>
                <Box
                  tag='div'
                  className={`AccessRequestHistoryBody-accordianBoxSubBody--subbodyList ${
                    index === task.length - 1 ? 'lastItem' : ''
                  }`}>
                  {Object?.keys(task)?.map((key) => {
                    if (FIELDS_TO_EXCLUDE.includes(key)) return null;

                    let fieldValue = task?.[key];

                    if (DATE_FIELDS.includes(key)) {
                      fieldValue = moment
                        .utc(fieldValue)
                        .local()
                        .format(`${globalDateFormat?.toUpperCase()} HH:mm:ss`);
                    }

                    if (Array.isArray(fieldValue)) {
                      fieldValue = JSON.stringify(fieldValue);
                    }

                    return (
                      <React.Fragment key={`${task?.taskId}-${key}`}>
                        {key !== 'taskLabel' && (
                          <span className='AccessRequestHistoryModalSubTitle-textBoxKey'>
                            {`${
                              messages[messageKeys?.[key]] ||
                              localize(intl, getMessageKey(messageKeys?.[key]))
                            }:`}
                            &nbsp;
                          </span>
                        )}
                        <span className='AccessRequestHistoryModalSubTitle-textBoxValue'>
                          {fieldValue}
                        </span>
                        <span className='AccessRequestHistoryModalSubTitle-textBoxTerminate' />
                      </React.Fragment>
                    );
                  })}
                </Box>
              </Box>
            </ARSAccordian>
          ))}
      </Box>
    </ARSAccordian>
  );
}

ARSTaskTile.propTypes = {
  taskSectionTileData: PropTypes.shape({
    arsTaskSectionLabelKey: PropTypes.string,
    arsTaskSectionLabeValue: PropTypes.string,
    arsTaskLabelKey1: PropTypes.string,
    arsTaskLabelKey2: PropTypes.string,
    arsTaskSectionLabelValue: PropTypes.string,
    arsTaskMap: PropTypes.shape({}),
    arsTaskList: PropTypes.arrayOf(PropTypes.shape({})),
    messageKeys: PropTypes.shape({}),
  }).isRequired,
  globalDateFormat: PropTypes.string.isRequired,
};

export default ARSTaskTile;
